class CompareProductsResults extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.collection = this.getCollectionFromURL()

    if (this.collection) {
      this.refreshResults(this.collection)
    }
  }

  setupListeners () {
    super.setupListeners()
    this.handleSelectChange = this.handleSelectChange.bind(this)
    this.listeners.add(document, 'click', this.handleSelectChange)
  }

  getCompareList () {
    const stateElement = this.els.state.element
    const products = stateElement?.dataset.products || ''

    return products
      .split(',')
      .map((handle) => handle.trim())
      .filter(Boolean)
  }

  async handleSelectChange (event) {
    const option = event.target.closest(
      '[data-compare-products-results-el="option"]',
    )

    if (!option || option.disabled) return

    const newHandle = option.dataset.handle
    const oldHandle = option.dataset.currentHandle || ''
    const collection = option.dataset.collection

    if (!newHandle || newHandle === oldHandle) return

    const compareKey = `compare-${collection}`
    const currentList = this.getCompareList()
    const nextList = [...currentList]

    if (oldHandle) {
      const index = currentList.indexOf(oldHandle)

      if (index === -1) return

      nextList[index] = newHandle
    } else if (!nextList.includes(newHandle)) {
      nextList.push(newHandle)
    }

    try {
      await window.BAO.Cart.updateCartAttributes({
        [compareKey]: nextList.join(','),
      })
    } catch (error) {
      console.error('Failed to update compare attribute:', error)

      return
    }

    await this.refreshResults(collection)

    window.drawers.activeDrawerKey = ''
  }

  async refreshResults (collection) {
    this.setAttribute('aria-busy', 'true')

    try {
      const response = await window.BAO.sectionRenderer.fetchSingle(
        'compare-products-results',
        `/collections/${collection}`,
      )

      const newDOM = window.BAO.sectionRenderer.convertToDOM(response)
      const section = newDOM.querySelector('.shopify-section') || newDOM

      this.els.body.element.innerHTML = section.innerHTML

      await this.updateRegiosPrices()
    } catch (error) {
      console.error('Failed to refresh results:', error)
    } finally {
      this.removeAttribute('aria-busy')
    }
  }

  async updateRegiosPrices () {
    const productElements = this.querySelectorAll(
      '[data-regios-dopp-generic-product-id]',
    )

    if (productElements.length === 0) return

    const api = await this.getRegiosApi()

    if (!api) return

    const calculations = new Map()

    for (const productElement of productElements) {
      const dataElement = productElement.querySelector('[data-regios-product]')

      if (!dataElement) continue

      let product

      try {
        product = JSON.parse(dataElement.textContent)
      } catch (error) {
        console.warn(
          '[CompareProductsResults] Could not parse Regios product data',
          error,
        )

        continue
      }

      if (!calculations.has(product.productId)) {
        calculations.set(
          product.productId,
          api.calculateDiscountedPrices(product),
        )
      }

      const priceContainer = productElement.querySelector(
        '.regios-dopp-generic-price-container',
      )
      const salePriceElement = priceContainer?.querySelector(
        '.regios-dopp-generic-price-item--sale',
      )
      const regularPriceElement = priceContainer?.querySelector(
        '.regios-dopp-generic-price-item--regular',
      )

      if (!priceContainer || !salePriceElement || !regularPriceElement) {
        continue
      }

      try {
        const { salePrice, regularPrice } = await calculations.get(
          product.productId,
        )

        const isDiscounted = salePrice.amount < regularPrice.amount

        this.updatePriceText(salePriceElement, salePrice.formatted)

        if (isDiscounted) {
          this.updatePriceText(regularPriceElement, regularPrice.formatted)

          regularPriceElement.style.removeProperty('display')

          priceContainer.classList.add('regios-dopp-generic-price--on-sale')
        } else {
          this.updatePriceText(salePriceElement, regularPrice.formatted)
          this.updatePriceText(regularPriceElement, '')

          regularPriceElement.style.display = 'none'

          priceContainer.classList.remove('regios-dopp-generic-price--on-sale')
        }
      } catch (error) {
        console.warn(
          `[CompareProductsResults] Could not calculate Regios price for product ${product.productId}`,
          error,
        )
      }
    }
  }

  updatePriceText (element, value) {
    const screenReaderElement = element.querySelector('.util-ScreenReaderOnly')

    element.replaceChildren()

    if (screenReaderElement) {
      element.append(screenReaderElement)
    }

    element.append(document.createTextNode(value))
  }

  getRegiosApi () {
    if (window.RegiosDOPP?.api?.v0) {
      return Promise.resolve(window.RegiosDOPP.api.v0)
    }

    return new Promise((resolve) => {
      const timeout = window.setTimeout(() => {
        resolve(null)
      }, 5000)

      window.addEventListener(
        'regios-dopp:api-initialized',
        (event) => {
          window.clearTimeout(timeout)

          resolve(event.detail.api)
        },
        { once: true },
      )
    })
  }

  getCollectionFromURL () {
    const params = new URLSearchParams(window.location.search)

    return params.get('collection')
  }
}

if (!customElements.get('compare-products-results')) {
  customElements.define('compare-products-results', CompareProductsResults)
}
